import { Fragment, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useOpenCashRegisterMutation } from '../../../redux/api/marktApi';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setCashRegisterSession } from '../../../redux/authSlice';
import { useNavigate } from 'react-router-dom';

const SelectCashRegisterModal = ({ runningSessions, show }) => {
  // const [showModal, setShowModal] = useState(false);
  const [selectedSession, setSelectedsession] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = () => {
    toast.info('Kassen Session ausgewählt');
    let sessionToSet = runningSessions.find(
      (session) => session.id === selectedSession
    );
    dispatch(setCashRegisterSession(sessionToSet));
  };

  useEffect(() => {
    if (runningSessions?.length > 0) {
      setSelectedsession(runningSessions[0].id);
    }
  }, [runningSessions]);

  return (
    <Fragment>
      <Modal show={show} backdrop={'static'}>
        <Modal.Header>
          <Modal.Title>Kasse auswählen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Für den Verkauf muss eine geöffnete Kasse ausgewählt werden:</p>
          <select
            value={selectedSession}
            onChange={(e) => setSelectedsession(e.target.value)}
            className='form-select'
          >
            {runningSessions?.map((s) => (
              <option key={s.id} value={s.id}>
                {s.cash_register_name}
              </option>
            ))}
          </select>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => navigate('/markt/cash-register/overview')}
          >
            Abbruch (zur Kassen Übersicht)
          </Button>
          <Button variant='success' onClick={handleSubmit}>
            Kasse auswählen
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default SelectCashRegisterModal;
